import React from 'react'
import IconButton from '@material-ui/core/IconButton'
import Tooltip from '@material-ui/core/Tooltip'
import DeleteIcon from '@material-ui/icons/Delete'
import * as actions from '../actions/TablaPedidoCamionesEnPlayaActions'
import { connect } from 'react-redux'

function OperacionesPedidos (props) {
  const { fecha } = props
  function onClick () {
    props.eliminarPedidoCamiones(fecha)
  }
  return (
    <div>
      <Tooltip title={'Eliminar Pedido'}>
        <IconButton onClick={onClick}>
          <DeleteIcon />
        </IconButton>
      </Tooltip>
    </div>
  )
}

const withRedux = connect(null, actions)

export default withRedux(OperacionesPedidos)
